<template>
  <div ref="BarChart" style="width: 100%; height: 100%"></div>
</template>

<script>
import * as echarts from "echarts";
import { px2rem } from "@/utils/rem";
import { generateBarChartTooltip } from "@/utils/tooltip";

export default {
  name: "BarChart",
  props: {
    data: {
      type: Array,
      default: () => [],
    },
    xAxis: {
      type: Array,
      default: () => ["TF Family 1", "TF Family 2"],
    },
  },
  emits: ["finished"],
  watch: {
    data: {
      handler() {
        this.chart && this.chart.dispose();
        this.init();
      },
      deep: true,
    },
  },
  data() {
    return {
      chart: null,
    };
  },
  mounted() {
    // this.init();
  },
  methods: {
    init() {
      let option = {
        tooltip: {
          show: true,
          backgroundColor: "transplant",
          borderColor: "transplant",
          borderWidth: 0,
          padding: 0,
          formatter(params) {
            return generateBarChartTooltip({
              name: params.name,
              value: params.value,
              primaryColor: params.color,
              borderColor: params.color,
            });
          },
        },
        xAxis: {
          type: "category",
          data: this.xAxis,
          // 文字
          axisLabel: {
            fontSize: px2rem(12),
          },
          // 轴线
          axisLine: {
            lineStyle: {
              width: px2rem(1),
            },
          },
          // 刻度
          axisTick: {
            lineStyle: {
              width: px2rem(1),
            },
          },
        },
        yAxis: {
          type: "value",
          axisLabel: {
            fontSize: px2rem(12),
          },
          // 轴线
          axisLine: {
            lineStyle: {
              width: px2rem(1),
            },
          },
          // 刻度
          axisTick: {
            lineStyle: {
              width: px2rem(1),
            },
          },
        },
        grid: {
          left: "15%",
          top: "2%",
          bottom: "10%",
        },
        series: [
          {
            data: this.data,
            type: "bar",
            showBackground: true,
            backgroundStyle: {
              color: "rgba(180, 180, 180, 0.2)",
            },
          },
        ],
      };
      this.chart = echarts.init(
        this.$refs.BarChart,
        {},
        {
          renderer: "svg",
        }
      );
      this.chart.setOption(option);
      this.chart.on("finished", () => {
        this.$emit("finished");
        this.chart.off("finished");
      });
    },
  },
  beforeDestroy() {
    // 在组件销毁前，销毁 ECharts 实例
    this.chart && this.chart.dispose();
  },
};
</script>

<style lang="scss" scoped></style>
